
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saved",
      function () {
        return require("private-next-pages/saved.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saved"])
      });
    }
  